import { render } from "./ReportIssueView.vue?vue&type=template&id=7abf57e3"
import script from "./ReportIssueView.vue?vue&type=script&lang=js"
export * from "./ReportIssueView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__